import React, { useEffect } from "react";
import { ADMIN_ROLES_FOR_ADMIN_SECTION, ALLOW_CHANGE_COMPANY_LOCATION, MODAL_SIZE, PREFERED_LANGUAGE_KEYS, USER_ROLES } from "../../App.config";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import ChangeCompanyModal from "../../containers/DisplayEmployeeName/ChangeCompanyModal";

const DisplayEmployeeName = ({ props, managersDetails, userAuthReducer, context, getAuthUserRoles, getAllCompanyList, resetCompanyIdInManagerData, getAllActiveCases }) => {

  const dispatch = useDispatch();
  const i18nReducer = useSelector((state) => state.i18nState);
  const modalAction = bindActionCreators(modalActions, dispatch);

  useEffect(() => {
    //The purpose of the condition check is because of in admin user add user section we have already call getAuthUserRoles Api and if that company does not have demo and level file access manager role should not display in the dropdown section thats why we check this condition
    managersDetails && managersDetails.roleId == USER_ROLES.ADMIN && userAuthReducer && userAuthReducer.selectedCompany ? getAuthUserRoles(userAuthReducer.selectedCompany) : getAuthUserRoles(0);
    getAllCompanyList();
    // getAuthUserRoles(0);
  }, []);

  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const onHandleChangeCompany = () => {
    let { lstAssignedCompany } = managersDetails;
    openSetModal(
      <ChangeCompanyModal context={context} companyList={userAuthReducer.companyList}
        resetCompanyIdInManagerData={resetCompanyIdInManagerData}
        lstAssignedCompany={lstAssignedCompany} />,
      MODAL_SIZE.MODAL_LG
    );
  }

  const returnAccessName = (selectedRole) => {
    let roleStr = "";
    let v = "fr_name";
    if (i18nReducer.lang == "en-US") {
      v = "name";
    }
    ADMIN_ROLES_FOR_ADMIN_SECTION.map(function (item) {
      if (item.authUserRoleId == selectedRole)
        roleStr = item[v]
    })
    return roleStr
  }

  const onCompanyChange = (e) => {
    resetCompanyIdInManagerData(e.target.value);
  }

  const openRoleInfoSwal = (selectedRole) => {
    let roleInfo = ""
    let roleStr = returnAccessName(selectedRole);
    switch (Number(selectedRole)) {
      case USER_ROLES.ADMIN:
        roleInfo = context.t("Dashboard.Access.Admin.Text");
        roleStr = context.t("Dashboard.Access.Admin");
        break;
      case USER_ROLES.FULL_HR:
        roleInfo = context.t("Dashboard.Access.FullHR.Text");
        roleStr = context.t("Dashboard.Access.FullHR");
        break;
      case USER_ROLES.LIMITED_CAL_HR:
        roleInfo = context.t("Dashboard.Access.LTDCallHR.Text");
        roleStr = context.t("Dashboard.Access.LTDCallHR");
        break;
      case USER_ROLES.LIMITED_CAL_MGR:
        roleInfo = context.t("Dashboard.Access.Manager.Text");
        roleStr = context.t("Dashboard.Access.Manager");
        break;
      case USER_ROLES.BROKER:
        // roleInfo = context.t("Dashboard.Access.Manager.Text");
        roleStr = context.t("Dashboard.Access.Broker");
        break;
    }

    swal(roleInfo, { title: roleStr, closeOnEsc: true });
  }
  return (
    <div className="Search-result">
      <div className="row">
        <div className="col-6 result-label">
          {managersDetails && managersDetails?.roleId != USER_ROLES.ADMIN && managersDetails?.ein ? context.t("DASHBOARD-Hello.text") + " " + managersDetails?.firstName + " " + managersDetails?.lastName + " - " + managersDetails?.ein + " - " : context.t("DASHBOARD-Hello.text") + " " + managersDetails?.firstName + " " + managersDetails?.lastName + " - "}
          <button type="button" onClick={() => openRoleInfoSwal(managersDetails?.roleId)} className="btn btn-info">{returnAccessName(managersDetails?.roleId)}</button>
        </div>
        {
          managersDetails?.roleId == USER_ROLES.BROKER && ALLOW_CHANGE_COMPANY_LOCATION.includes(window.location.hash) &&
          <div className="col-6 btn-changecompany">
            {/* <button type="button" onClick={() => onHandleChangeCompany()} className="btn btn-info">Change Company</button> */}
            <select className="form-control form-control-lg" onChange={onCompanyChange}>
              {managersDetails && managersDetails.lstAssignedCompany.map((assignedCompanyId) => {
                if (userAuthReducer && userAuthReducer.companyList) {
                  for (let i = 0; i < userAuthReducer.companyList.length; i++) {
                    if (userAuthReducer.companyList[i].companyId == assignedCompanyId) {
                      return (
                        <option selected={managersDetails.companyId == userAuthReducer.companyList[i].companyId} value={userAuthReducer.companyList[i].companyId}>
                          {userAuthReducer.companyList[i].companyName}
                        </option>
                      )
                    }
                  }
                }
              })
              }
            </select>
          </div>
        }

      </div>
    </div>
  );
};
export default DisplayEmployeeName;
